import { Order }   from "../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import { Global } from './model';
import {
  PLANNER_SCROLL_UPDATED,
  PLANNER_SCROLL_CONTENT_POSITION
} from 'apps/events';
import {
  ScrollModel
} from './model';
export class Lines extends Order {
  linesWrap: HTMLElement;
  scrollContainer: HTMLElement;
  phaseIndex: any;
  specificPhases: any;
  init(){
    super.init();
    this.specificPhases = Global.getData('planner').phases;
    this.watch();
    this.listenMount([this.onMountLines]);
  }
  onMountLines(){
    this.linesWrap       = <HTMLElement>this.querySelector('.lines-wrap');
    this.scrollContainer = <HTMLElement>this.querySelector('.scroll-container');
    document.addEventListener(PLANNER_SCROLL_UPDATED, (e) => this.onUpdateScroll(e));
    document.addEventListener(PLANNER_SCROLL_CONTENT_POSITION, (e) => this.setContentPosition(e));
  }
  onChangeStore(a,b,c){
    if(this.opts.lines != a.lines){
      this.opts.lines = null; // 一度lineを消すため
      this.update();
    }
    super.onChangeStore(a, b, c);
  }
  getContainerWidth():number{
    return this.linesWrap.clientWidth;
  }
  getContentWidth():number{
    return this.linesWrap.scrollWidth;
  }
  onUpdateScroll(e){
    // console.log(e)
  }
  setContentPosition(e){
    let scrollModel: ScrollModel = e.detail;
    this.scrollContainer.style.marginLeft = scrollModel.contentPosition + 'px';
  }
  hasSpecificPhase(id){
    if(this.specificPhases == null){ return true; }
    if(this.specificPhases.length <= 0){ return true; }
    let ss = Global.getLineData(id).schedules;
    for(let i=0; i<ss.length; i++){
      let schedule_id = ss[i]
      let s_data = Global.getScheduleData(schedule_id)
      let t_data = Global.getTaskData(s_data.task_id);
      for(let j=0; j<this.specificPhases.length; j++){
        if(this.specificPhases[j] == t_data.phase_id){
          return true;
        }
      }
    }
    return false;
  }
}
riot.mixin('orders.planner.lines', Lines as riot.TagMixin)
